// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-btn[data-v-1edb32f7] {\n  font-size: 0.93rem !important;\n  padding: 0.8rem 2.8rem !important;\n  height: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
